import { createSlice } from '@reduxjs/toolkit';
import type { WhiltelabelSliceType } from '../../types/whitelabelTypes';
import thunk from './whitelabelThunk';
import { generateTotalMRRWithBreakdown } from '../../utils/generateTotalMRRWithBreakdown';

const initialState: WhiltelabelSliceType = {
  subscriptionTierMRR: {
    totalMRR: 0,
    breakdown: [],
  },
  skiptraceStats: {
    totalRevenue: 0,
    totalSkiptrace: 0,
    totalBalance: 0,
    avgSkiptraceOrder: 0,
    data: [],
  },
  userStats: {
    totalUsers: 0,
    newUsersThisMonth: 0,
    unSubscribedUsers: 0,
    data: [],
  },
  addition: {
    errorMessage: '',
    isLoading: false,
  },
};

export const whiltelabelSlice = createSlice({
  name: 'whiltelabelSlice',
  initialState,
  reducers: {
    setLoading: (state) => {
      state.addition.isLoading = true;
    },
    unsetLoading: (state) => {
      state.addition.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(thunk.getSkiptraceStats.fulfilled, (state, { payload }) => {
      if (!payload) {
        return state;
      }
      state.skiptraceStats = payload;
    });
    builder.addCase(thunk.getUserStats.fulfilled, (state, { payload }) => {
      if (!payload) {
        return state;
      }
      state.userStats = {
        ...payload,
        unSubscribedUsers: payload.data.find((item) => item.name.toUpperCase() === 'FREE')?.value ?? 0,
        data: payload.data.filter((item) => item.name.toUpperCase() !== 'FREE'),
      };
      state.subscriptionTierMRR = generateTotalMRRWithBreakdown(payload.data);
    });
  },
});

export const {
  setLoading, unsetLoading,
} = whiltelabelSlice.actions;
export default whiltelabelSlice.reducer;
